// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"92654485","425":"aafa3ba6","510":"02b95786","532":"414d80e7","633":"904e62b5","634":"bd6f18df","922":"4dfce607","937":"18eda94f","972":"42d93275"}[chunkId] + ".chunk.js";
};